import React, { useState, useEffect } from "react";
import { DataItem, Button, Dialog, FooterAction } from "@deere/isg.component-library";
import {
  StatusEquipmentWorking,
  IconMarkerEmpty,
  IconNavigationTools,
  IconStar,
} from "@deere/icons/new";

interface Props {
  mission: any;
  open: boolean;
  onClose: () => void;
  onConfirm: (startIndex: number) => void;
}

export const MissionTaskSelector: React.FC<Props> = ({ mission, open, onClose, onConfirm }) => {
  const [selectedTaskIndex, setSelectedTaskIndex] = useState<number>(0);
  const [flattenedTasks, setFlattenedTasks] = useState<any[]>([]);

  useEffect(() => {
    if (mission) {
      const tasks: any[] = [];
      const reps = mission.taskRepetitions || 1;
      for (let i = 0; i < reps; i++) {
        if (mission.tasks) {
          mission.tasks.forEach((task: any, index: number) => {
            // We can add more meaningful description based on task type
            let desc = `Task ${index + 1}`;
            if (task.action === "Navigate") {
              desc = `Navigate to ${task.pointName || "Waypoint"}`;
            } else if (task.action === "Command") {
              desc = `Command: ${task.properties?.workType || "Action"}`;
            }

            tasks.push({
              originalTask: task,
              repetitionIndex: i,
              description: desc,
              id: tasks.length,
            });
          });
        }
      }
      setFlattenedTasks(tasks);
      setSelectedTaskIndex(0);
    }
  }, [mission]);

  const handleConfirm = () => {
    onConfirm(selectedTaskIndex);
    onClose();
  };

  const footerActions: FooterAction[] = [
    {
      title: "Cancel",
      onClick: onClose,
      variant: "secondary",
    },
    {
      title: "Confirm Start Task",
      onClick: handleConfirm,
      variant: "primary",
    },
  ];

  return (
    <Dialog
      open={open}
      title="Select Start Task"
      footerActions={footerActions}
      closeHandler={onClose}
      width="md"
    >
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <p style={{ margin: "16px" }}>
          Select the task you want to start the mission from. All previous tasks will be skipped.
        </p>
        {flattenedTasks.map((taskItem, index) => (
          <div
            key={index}
            onClick={() => setSelectedTaskIndex(index)}
            style={{
              cursor: "pointer",
              backgroundColor: selectedTaskIndex === index ? "#e6f7ff" : "transparent",
              borderLeft:
                selectedTaskIndex === index ? "4px solid #0078d4" : "4px solid transparent",
            }}
          >
            <DataItem
              title={`${taskItem.description} (Repetition ${taskItem.repetitionIndex + 1})`}
              subtitle={
                typeof taskItem.originalTask.navigateItem === "string"
                  ? taskItem.originalTask.navigateItem
                  : taskItem.originalTask.navigateItem?.title || ""
              }
              icon={
                selectedTaskIndex === index ? (
                  <IconStar size={24} color="#0078d4" />
                ) : (
                  <IconMarkerEmpty size={24} />
                )
              }
            />
          </div>
        ))}
      </div>
    </Dialog>
  );
};
